import { useLocalAuth } from '@wehunt/core-web'
import { AuthenticatedApp } from './AuthenticatedApp'
import { ErrorScreen } from './screens/ErrorScreen'
import { SignInScreen } from './screens/SignInScreen'
import { SplashScreen } from './screens/SplashScreen'

// Deliberately no router: the screens are none of them linkable, and the
// choice between them is a function of auth state rather than of a URL.
export function App() {
  const { state, signInWithGoogle } = useLocalAuth()

  switch (state.status) {
    case 'loading':
      return <SplashScreen />
    case 'signed-out':
      return <SignInScreen onSignIn={signInWithGoogle} />
    case 'error':
      return <ErrorScreen onRetry={() => window.location.reload()} />
    case 'signed-in':
      return <AuthenticatedApp />
  }
}
